export enum DecisionSubjectTypesEnum {
  FIZ = 'Физические лица',
  UR = 'Юридические лица',
  IP = 'Индивидуальные предприниматели',
  IFIZ = 'Иностранные физические лица',
  IUR = 'Иностранные юридические лица',
  FIUR = 'Филиалы иностранных юридических лиц',
}
